/**
 * RandomSelector.js
 * Utility class to implement a weighted random selection among a list of possible choices
 */

export class RandomSelector {
    /**
     * @public
     */
    constructor() {
        /** @private @type {Object[]} */
        this._choices = [];

        /** @private @type {Number} */
        this._totalWeight = 0;
    }

    /**
     * Adds a possible choice with the specified probability
     * @public
     * @param {Object} object
     * @param {Number} weight
     */
    addChoice(object, weight) {
        if (weight <= 0) {
            return;
        }

        this._choices.push({
            object: object,
            weight: weight
        });

        this._totalWeight += weight;
    }

    /**
     * @public
     */
    reset() {
        this._choices = [];
        this._totalWeight = 0;
    }

    /**
     * Performs a weighted random selection among the defined choices
     * @public
     * @returns {Object}
     */
    choose() {
        const randomScore = Math.random() * this._totalWeight;
        let scannedWeight = 0;
        for (let i = 0; i < this._choices.length; ++i) {
            const choice = this._choices[i];
            scannedWeight += choice.weight;
            if (randomScore <= scannedWeight) {
                return choice.object;
            }
        }
        return null;
    }

    /**
     * @public
     */
    destroy() {
        this.reset();
    }
}
